import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ContractIcon({ fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon height={height ?? 24} viewBoxDimensions="0 0 24 24" width={width ?? 24}>
      <path
        d="M22.625 20.938c0 .759-.616 1.375-1.375 1.375H4.75c-.76 0-1.375-.616-1.375-1.375V3.063c0-.76.616-1.376 1.375-1.376h13.791c.36 0 .704.14.96.391l2.709 2.643c.265.259.415.614.415.984v15.233zM7.541 9.313h11c.414 0 .75-.336.75-.75 0-.415-.336-.75-.75-.75h-11c-.414 0-.75.335-.75.75 0 .414.336.75.75.75zm0 4.124h11c.414 0 .75-.335.75-.75 0-.414-.336-.75-.75-.75h-11c-.414 0-.75.336-.75.75 0 .415.336.75.75.75zm0 4.126h5.5c.414 0 .75-.336.75-.75 0-.415-.336-.75-.75-.75h-5.5c-.414 0-.75.335-.75.75 0 .414.336.75.75.75z"
        fill={fill ?? IconColors.Primary}
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
